module.exports = __webpack_public_path__ + "img/category-casino-hover.858ed4f8.png";